import React, {FC, useEffect} from 'react';
import {useStoreon} from 'storeon/react';
import {GxButton, GxSpinner} from '@garpix/garpix-web-components-react';
import {FormikProps} from 'formik';
import 'react-responsive-modal/styles.css';
import {toast} from 'react-toastify';
import { Events, State } from '@/interfaces';
import useModalFlag from '../../../../../hooks/useModalFlag';
import {IInitialValues} from '../types';
import styles from '../styles/index.module.scss';
import Button from '../../../../../components/Button';
import ModalPayCertificateOrDeposit from '../../ModalPayCertificateOrDeposit';
import {TYPE_USER} from '../../../../../const';

interface IModalUserfooter {
    formik: FormikProps<IInitialValues>,
    onRequestClose: () => void,
    isLoading: boolean,
    isEdit: boolean,
    userData: any,
}

const translateErrors = {
    'phone': 'телефон',
    'email': 'e-mail',
    'first_name': 'имя',
    'last_name': 'фамилия'
}


const ModalUserFooter: FC<IModalUserfooter> = ({formik, onRequestClose, isLoading, isEdit, userData}) => {
    const {flag, setModalFlag} = useModalFlag();
    const {currentUser} = useStoreon<State, Events>('currentUser');

    const {submitForm} = formik;


    useEffect(() => {
        if (Object.keys(formik.errors).length) {
            let errors = ''
            Object.keys(formik.errors).map((key) => {
                const formikErrors: any = formik.errors;
                const err = Object.keys(formikErrors[key as keyof typeof formikErrors]).map((elem) => translateErrors?.[elem as keyof typeof translateErrors] || elem)
                errors += `${err.join(', ')}`
                return key
            })
            toast.error(`Заполните все обязательные поля: ${errors}`);
        }
    }, [formik.errors])

  return (
    <>
      {currentUser.user_status !== TYPE_USER.VIEWER &&
        <div className={styles['footer']}>
            <div className={styles['footer--left-block']}>
              <Button
                className={styles['footer--sell-btn']}
                theme='btn--outline_blue'
                onClick={setModalFlag}
              >
                Продажа
              </Button>
            </div>
            <div className={styles['footer--right-block']}>
              <GxButton className={styles['footer--btn']} onClick={onRequestClose}>Отмена</GxButton>
              <GxButton type='submit' className={styles['footer--btn']}
                onClick={submitForm}>
                {isLoading && <GxSpinner />} {isEdit ? 'Изменить' : 'Сохранить'}
              </GxButton>
            </div>
        </div>
      }
      {flag && <ModalPayCertificateOrDeposit userData={userData} flag={flag} onRequestClose={setModalFlag} />}
    </>
  )
}

export default ModalUserFooter;